// extracted by mini-css-extract-plugin
export var primitiveLabel = "_u7-0";